import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import { InsumoOrdemProducao } from "app/types/OrdemProducao";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";

const estilosInputs = require('../../../estilos/inputs.module.scss').default
const estilosBotoes = require("../../../estilos/botoes.module.scss").default;
const estiloTabela = require('../../../estilos/tabelas.module.scss').default

type ConsultarInsumoOrdemProducaoProps = {
    insumosSelecionados: InsumoOrdemProducao[]
    listaQuantidade: { codigo: string, quantidade: number }[]
    situacaoOrdemProcucao: number
    dadosInsumoOrdemProducao: InsumoOrdemProducao[]
    onIncluirInsumo: () => void
    onRemoverInsumo: () => void
    onSelecionarInsumo: (insumo: InsumoOrdemProducao) => void
    onAlterarQuantidade: (quantidade: number, codigoProduto: string, quantidadeOriginal: number) => void
    permitirPersonalizacaoOrdemProducao: boolean
}

export const ConsultarInsumoOrdemProducao = (props: ConsultarInsumoOrdemProducaoProps) => {


    const [listaQuantidade, setListaQuantidade] = useState<{ codigo: string, quantidade: number }[]>()


    const onConfirmarAlteracaoQuantidade = (quantidade: number, codigo: string, quantidadeOriginal: number) => {

        const novaListaQuantidade = [...listaQuantidade];
        const index = novaListaQuantidade.findIndex(item => item.codigo === codigo);
        if (index !== -1) {
            novaListaQuantidade[index] = { codigo, quantidade };
        } else {
            novaListaQuantidade.push({ codigo, quantidade });
        }
        setListaQuantidade(novaListaQuantidade);
        props.onAlterarQuantidade(quantidade, codigo, quantidadeOriginal)
    }

    const headerTabelaInsumos = () => {
        const mapHeader = ["Código", "Referência", "Descrição", "Quantidade", "Reserva", "Estoque Atual", "Estoque Dísponivel", "Entrada Futura", "Saldo Futuro"]

        return mapHeader.map((nome, index) => 
                <th key={nome} 
                    className={`_table-cell`}
                    style={ (index >= 3)
                            ? { textAlign: 'right' } 
                            : {}
                    } 
                >
                    {nome}
                </th>)
    }

    useEffect(() => {
        setListaQuantidade(props.listaQuantidade)
    }, [props.listaQuantidade])

    const bodyTabelaInsumos = (index: number, dado: InsumoOrdemProducao, situacaoOrdemProcucao: number) => {

        const inputQuantidade = <InputNumerico
            valor={listaQuantidade?.find(item => item.codigo === dado?.CodigoProdutoInsumo)?.quantidade}
            id={`ConsultarInsimoOrdemProducao_inputQuantidade_${index}`}
            numeroCasasDecimais={3}
            onValorModificado={(valor) => onConfirmarAlteracaoQuantidade(valor, dado?.CodigoProdutoInsumo, dado.QuantidadeFinal)}
            selecionaValorOnFocus={true}
            classesInput={["_w-full"]}
            disabled={!props.permitirPersonalizacaoOrdemProducao}

        />

        const mapHeader = [
                dado.CodigoProdutoInsumo,
                dado.CodigoInterno, 
                globalMU.isNotNullOrEmpty(dado.DescricaoLonga) ? dado.Descricao : dado.DescricaoLonga,
                inputQuantidade, 
                globalMU.formatarValorNumerico(dado.QuantidadeReservada, 3, false), 
                globalMU.formatarValorNumerico(dado.QuantidadeEstoque, 3, false),
                globalMU.formatarValorNumerico(dado.QuantidadeDisponivel, 3, false), 
                globalMU.formatarValorNumerico(dado.EntradaFutura, 3, false), 
                globalMU.formatarValorNumerico(dado.SaldoFuturo, 3, false)
            ]

        return mapHeader.map((nome: string, index: number) => 
            <td 
                style={(index == 0 && situacaoOrdemProcucao == 40090 && (dado.Quantidade - dado.QuantidadeReservada - dado.QuantidadeInsumo) < 0) 
                    ? { boxShadow: 'inset 4px 0px #FF0000' } 
                    : (index >= 4)
                            ? { textAlign: 'right' } 
                            : {}
                    } 
                key={`${nome}_${index}`} 
                id={`${nome}_${index}`} 
                className="_table-cell"
            >
                {nome}
            </td>)
    }
    return (
        <>

            <div className="_flex _my-4">
                <div className="_flex _items-center _px-10">
                    <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoIcone} ${estilosBotoes.botaoIconeVerde}`}
                        onClick={() => props.onIncluirInsumo()}
                        disabled={!props.permitirPersonalizacaoOrdemProducao}>
                        <FontAwesomeIcon
                            icon={faCirclePlus}
                            color={"#5ac93c"}
                            fontSize={20}
                        />
                        Incluir
                    </button>
                    
                    <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoIcone} ${estilosBotoes.botaoIconeVermelho}`}
                        onClick={() => props.onRemoverInsumo()}
                        disabled={!props.permitirPersonalizacaoOrdemProducao || props.insumosSelecionados?.length <= 0}>
                        <FontAwesomeIcon
                            icon={faTimesCircle}
                            color={"#f25713"}
                            fontSize={20}
                        />
                        Remover
                    </button>
                </div>
            </div>

            <div className="_py-2">
                <div className="_overflow-auto">
                <table className={`_table _w-full _border-collapse ${estiloTabela.tabela}`}>
                    <thead className="_table-header-group">
                        <tr className="_table-row">
                            {headerTabelaInsumos()}
                        </tr>
                    </thead>

                    <tbody className="_table-row-group">
                        {props.dadosInsumoOrdemProducao?.map((dado, index) => (
                            <tr className={`_table-row ${estiloTabela.linhaClicavel} ${props.insumosSelecionados.includes(dado) && estiloTabela.linhaSelecionada}`}
                                key={index}
                                onClick={() => props.onSelecionarInsumo(dado)}>
                                {bodyTabelaInsumos(index, dado, props.situacaoOrdemProcucao)}
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>

            </div>

            <div className="_my-4">
                <Legenda itens={[
                    {
                        nome: "Insumo com Estoque Indisponível",
                        cor: "#FF0000",
                    }]}
                />
            </div>
        </>
    )
}